import { TsmVirtualCode, replaceRange } from "ts-macro";
import path from "node:path";
import "@volar/typescript";

//#region src/$$this-fixer-plugin.ts
function $$thisFixerPlugin() {
	const $$thisRegex = /\$\$this/g;
	return {
		name: "ets:$$this-fixer",
		resolveVirtualCode(virtualCode) {
			const text = virtualCode.ast.getText();
			const matches = text.matchAll($$thisRegex);
			for (const match of matches) {
				const start = match.index;
				const end = start + match[0].length;
				replaceRange(virtualCode.codes, start, end, [
					"this",
					match[0],
					start + 2,
					{
						completion: true,
						format: true,
						navigation: true,
						semantic: true,
						structure: true,
						verification: true
					}
				]);
			}
		}
	};
}

//#endregion
//#region src/ets-code.ts
function createVirtualCode(snapshot, languageId, data) {
	return {
		id: "root",
		languageId,
		snapshot,
		mappings: [{
			sourceOffsets: [0],
			generatedOffsets: [0],
			lengths: [snapshot.getLength()],
			data
		}]
	};
}
function createEmptyVirtualCode(snapshot, languageId, data) {
	return {
		id: "root",
		languageId,
		snapshot: {
			getText: () => "",
			getLength: () => 0,
			getChangeRange: () => void 0
		},
		mappings: [{
			sourceOffsets: [0],
			generatedOffsets: [0],
			lengths: [snapshot.getLength()],
			data
		}]
	};
}
var ETSVirtualCode = class extends TsmVirtualCode {};

//#endregion
//#region src/language-plugin.ts
function isEts(tsOrEts) {
	return "ETS" in tsOrEts.ScriptKind && tsOrEts.ScriptKind.ETS === 8;
}
function ETSLanguagePlugin(tsOrEts, { sdkPaths = [], tsdk = "" } = {}) {
	const isETSServerMode = isEts(tsOrEts);
	const isTSPluginMode = !isETSServerMode;
	const getDisabledVirtualCode = (snapshot, languageId) => createVirtualCode(snapshot, languageId, {
		completion: false,
		format: false,
		navigation: false,
		semantic: false,
		structure: false,
		verification: false
	});
	return {
		getLanguageId(uri) {
			const filePath = typeof uri === "string" ? uri : uri.fsPath;
			if (filePath.endsWith(".ets")) return "ets";
			if (filePath.endsWith(".ts")) return "typescript";
			return void 0;
		},
		createVirtualCode(uri, languageId, snapshot) {
			const filePath = path.resolve(typeof uri === "string" ? uri : uri.fsPath);
			const isInSdkPath = sdkPaths.some((sdkPath) => filePath.startsWith(sdkPath));
			const isInTsdkPath = filePath.startsWith(tsdk);
			const isDTS = filePath.endsWith(".d.ts");
			const isDETS = filePath.endsWith(".d.ets");
			if (languageId === "ets" && filePath.endsWith(".ets")) return new ETSVirtualCode(filePath, tsOrEts.createSourceFile(filePath, snapshot.getText(0, snapshot.getLength()), 99), "typescript", [$$thisFixerPlugin()]);
			if (isETSServerMode && !(isDTS || isDETS) && !isInSdkPath) return getDisabledVirtualCode(snapshot, languageId);
			if (isTSPluginMode && (isDTS || isDETS) && isInSdkPath) return createEmptyVirtualCode(snapshot, languageId, {
				completion: false,
				format: false,
				navigation: false,
				semantic: false,
				structure: false,
				verification: false
			});
			if (isETSServerMode && (isDTS || isDETS) && isInTsdkPath) return getDisabledVirtualCode(snapshot, languageId);
		},
		typescript: {
			extraFileExtensions: isETSServerMode ? [{
				extension: "ets",
				isMixedContent: false,
				scriptKind: 8
			}, {
				extension: "d.ets",
				isMixedContent: false,
				scriptKind: 8
			}] : [],
			resolveHiddenExtensions: true,
			getServiceScript(root) {
				return {
					code: root,
					extension: ".ets",
					scriptKind: 3
				};
			}
		}
	};
}

//#endregion
export { $$thisFixerPlugin, ETSLanguagePlugin, ETSVirtualCode };
//# sourceMappingURL=index.mjs.map